import { QuestionOutlineIcon } from "@chakra-ui/icons";
import { Box, Flex, Text } from "@chakra-ui/react";
import { Link as RouterLink } from "react-router-dom";
import { WizardStep } from "../types";

const STEPS: Array<{ step: WizardStep; label: string }> = [
  { step: 1, label: "Service" },
  { step: 2, label: "Documents" },
  { step: 3, label: "Options" },
  { step: 4, label: "Payment" },
];

export default function ProgressBar(props: {
  step: WizardStep;
  maxStep: WizardStep;
  onStepClick: (step: WizardStep) => void;
  showSteps?: boolean;
  showHelp?: boolean;
  showProgress?: boolean;
  withBorder?: boolean;
}) {
  const {
    step,
    maxStep,
    onStepClick,
    showSteps = true,
    showHelp = true,
    showProgress = true,
    withBorder = true,
  } = props;

  return (
    <Box
      w="100%"
      pt="7px"
      pb="7px"
      borderBottom={withBorder ? "1px solid #E6ECF3" : undefined}
      display="flex"
      justifyContent="center"
      position="relative"
    >
      <Flex w="496px" height="50px" alignItems="center" justifyContent="space-between" position="relative">
        {showProgress && (
          <Box position="absolute" left="12.5%" right="12.5%" top="14px" height="4px">
            <Box position="absolute" left="0" right="0" top="0" height="4px" borderRadius="999px" bg="#D2DAE5" />
            <Box
              position="absolute"
              left="0"
              top="0"
              height="4px"
              borderRadius="999px"
              bg="#2F80ED"
              width={`${((step - 1) / 3) * 100}%`}
              transition="width 180ms ease"
            />
          </Box>
        )}

        {showSteps &&
          STEPS.map(({ step: s, label }) => {
            const isActive = s === step;
            const isClickable = s <= maxStep;
            const isDone = s < step;

            return (
              <Flex
                key={s}
                direction="column"
                alignItems="center"
                zIndex={1}
                cursor={isClickable ? "pointer" : "default"}
                onClick={() => {
                  if (!isClickable) return;
                  onStepClick(s);
                }}
                userSelect="none"
                flex="1"
                minW="0"
              >
                <Box
                  w="16px"
                  h="16px"
                  borderRadius="999px"
                  bg={isActive || isDone ? "#2F80ED" : "#D2DAE5"}
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                >
                  <Box
                    w="10px"
                    h="10px"
                    borderRadius="999px"
                    bg={isActive ? "#FFFFFF" : isDone ? "#2F80ED" : "#D2DAE5"}
                    opacity={isActive ? 1 : 0.9}
                  />
                </Box>
                <Text
                  fontSize="14px"
                  lineHeight="1.2"
                  fontWeight="400"
                  color={isActive || isDone ? "#2F80ED" : "#667085"}
                  whiteSpace="nowrap"
                  overflow="hidden"
                  textOverflow="ellipsis"
                >
                  {label}
                </Text>
              </Flex>
            );
          })}
      </Flex>

      {showHelp && (
        <Flex
          as={RouterLink}
          to="/customer/support"
          position="absolute"
          left="0"
          right="0"
          top="50%"
          transform="translateY(-50%)"
          alignItems="center"
          justifyContent="flex-end"
          gap="6px"
          px={{ base: "24px", md: "80px" }}
          color="#0B0E10"
          cursor="pointer"
        >
          <QuestionOutlineIcon boxSize="20px" />
          <Text fontSize="12px" fontWeight="400">
            Help
          </Text>
        </Flex>
      )}
    </Box>
  );
}
